'use strict';

angular.module('selfAccessRequestControllers')

    .controller('AdHocOtherCatalogController',
                 ['$scope', '$q', '$state', '$translate', 'topBar', '$stateParams', 'selfAccessRequestService', 'selfAccessRequest', 'searchService', 'decisionSystemTypesList', 'processStep', 'decisionLookUpsById',
        function ($scope, $q, $state, $translate, topBar, $stateParams, selfAccessRequestService, selfAccessRequest, searchService, decisionSystemTypesList, processStep, decisionLookUpsById) {

            // Load translation asynchronously to avoid race condition
            $translate('iam.selfAccessRequest.adHoc.pageTitle').then(function(translation) {
                topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                       '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-shopping-cart');
            });

            var requestTimeout;
            
            // Init Selected System Roles Decisions
            var sysRolesDecisionsBySystemType = [];
            updateSystemRoleDecisionList(decisionSystemTypesList);

            $scope.currentUserId = selfAccessRequest.EmployeeID;
            $scope.processStep = processStep;
            $scope.areDecisionsCreated = decisionSystemTypesList.length > 0;

            // Update Selected Systems
            $scope.updateSelectedSystems = function (decision) {
                decision.Decision.WithImpact = true;

                selfAccessRequestService
                    .getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId,
                                                             'OtherCatalogPermissions')
                    .then(function (userSystemRoleDecisionList) {
                        updateSystemRoleDecisionList(userSystemRoleDecisionList);
                    })
            }

            // Select a system type and generating the data
            $scope.selectSystemType = function ($item) {

                selfAccessRequestService
                    .createOtherCatalogDecisions($stateParams.userAccessRequestId, $item.SystemID)
                    .then(function (system) {
                        if (!_.isUndefined(system)) {
                            $scope.systemWithDecisions = system.SystemWithDecisions;
                            $scope.areDecisionsCreated = true;
                        }

                    });

            }

            // Confirm all system types and Confirm Step
            $scope.confirmAll = function () {

                var currentUserSystemRoleDecisionList = new Array();
                _.forEach(sysRolesDecisionsBySystemType, function (systemType) {
                    _.forEach(systemType.SystemList, function (sysListItem) {
                        _.forEach(sysListItem.UserSystemRoleDecisionList, function (decision) {
                            currentUserSystemRoleDecisionList.push(decision);
                        })
                    });
                });

                selfAccessRequestService
                    .confirmUserSystemRoleDecisionList($stateParams.userAccessRequestId, currentUserSystemRoleDecisionList)
                    .then(function (data) {
                        selfAccessRequestService
                            .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'OtherCatalogPermissions')
                            .then(function (data) {
                                $state.go('selfAccessRequest', {
                                    userAccessRequestId: $stateParams.userAccessRequestId
                                }, {
                                    reload: true
                                });
                            });
                    });
            }

            // Skip Other Catalog
            $scope.skipOtherCatalog = function () {
                selfAccessRequestService
                 .skipProcessStepForSelfAccessRequest(selfAccessRequest.UserAccessRequestID,
                                                      processStep.Step)
                 .then(function () {
                     $scope.goToAdHocSteps();
                 });
            }

            // Search for available systems
            $scope.search = function (q) {
                var MIN_SEARCH_LENGTH = 2;

                if (requestTimeout) {
                    requestTimeout.resolve('New search query, current requests cancelled');
                }
                requestTimeout = $q.defer();

                if (q.length >= MIN_SEARCH_LENGTH) {
                    $scope.afterSearching = false;

                    $q.all([selfAccessRequestService.searchAvailableSystemsForSelfAccessRequest($stateParams.userAccessRequestId, q)])

                        .then(function (foundSystems) {
                            $scope.hasResults = foundSystems[0].length > 0;
                            $scope.results = foundSystems[0];
                            $scope.afterSearching = true;
                            requestTimeout = null;
                        });
                }

                if (!$scope.$$phase) $scope.$apply();
            };

            // Assigning variables for Views
            $scope.currentSystemTypes = decisionSystemTypesList;

            // Go To AdHoc Steps
            $scope.goToAdHocSteps = function () {
                $state.go('selfAccessRequest', {
                    userAccessRequestId: $stateParams.userAccessRequestId
                }, {
                    reload: true
                });
            }

            // Helpers
            function updateSystemRoleDecisionList(systemRoleDecisionList) {

                sysRolesDecisionsBySystemType = _.cloneDeep(systemRoleDecisionList);

                $scope.totalSelectedRoles = 0;
                $scope.selectedDecisionWithImpactList =
                    _.chain(systemRoleDecisionList)
                        .map(function (systemType) {

                            systemType.SystemList =
                                _.chain(systemType.SystemList)
                                 .map(function (system) {
                                     system.UserSystemRoleDecisionList =
                                         _.chain(system.UserSystemRoleDecisionList)
                                          .map(function (sysRoleDecision) {
                                              sysRoleDecision.Decision =
                                                  decisionLookUpsById[sysRoleDecision.SelfAccessRequestProcessStepDecisionID];
                                              if (sysRoleDecision.Decision.WithImpact) {
                                                  $scope.totalSelectedRoles++;
                                              }
                                              return sysRoleDecision;
                                          })
                                             .reject(function (sysRoleDecision) {
                                                 return !sysRoleDecision.Decision.WithImpact;
                                             })
                                             .value();
                                     return system;
                                 })
                                    .filter(function (system) {
                                        return _.size(system.UserSystemRoleDecisionList) > 0
                                    })
                                    .value();

                            return systemType;
                        })
                        .filter(function (systemType) {
                            return _.size(systemType.SystemList) > 0;
                        })
                        .value();
            }
        }
    ]);